import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import { useParams } from "react-router-dom";
// import LanguageIcon from '@mui/icons-material/Language';
import QRCode from "qrcode";
import { baseURL, baseURLIO } from "../../../../../global/api";

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);

const MailIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

const VerifiedIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" fill="#16a34a" />
    <polyline points="8,12 11,15 16,9" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const styles = `
  * { box-sizing: border-box; }

  .cd-page {
    min-height: 100vh;
    background: #0a0a0a;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 48px 16px 80px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }

  .cd-card {
    width: 100%;
    max-width: 500px;
    background: #141414;
    border: 0.5px solid rgba(255,255,255,0.08);
    border-radius: 20px;
    overflow: hidden;
    animation: fadeUp .35s ease both;
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  /* ── COVER ── */
.cd-cover {
  height: 110px;
  background: #1a1a1a;
  border-bottom: 0.5px solid rgba(255,255,255,0.06);
  position: relative;
  overflow: visible;
}

.cd-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0.6;
  border-radius: 20px 20px 0 0;
}

  /* ── AVATAR ── */
.cd-avatar-wrap {
  position: absolute;
  bottom: -30px;
  left: 22px;
  z-index: 10;
}

  .cd-avatar {
    width: 62px;
    height: 62px;
    border-radius: 14px;
    border: 3px solid #141414;
    background: #1c2a3a;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    font-weight: 600;
    color: #60a5fa;
    overflow: hidden;
    position: relative;
  }

  .cd-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .cd-avatar-tick {
    position: absolute;
    bottom: -4px;
    right: -4px;
    width: 19px;
    height: 19px;
    border-radius: 50%;
    background: #16a34a;
    border: 2.5px solid #141414;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ── BODY ── */
  .cd-body {
    padding: 42px 22px 16px;
  }

  .cd-name-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 6px;
  }

  .cd-name-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .cd-name {
    font-size: 17px;
    font-weight: 600;
    color: #f1f1f1;
    margin: 0;
    letter-spacing: 0.01em;
  }

  .cd-badge-active {
    font-size: 11px;
    font-weight: 500;
    background: #0d2e1a;
    color: #4ade80;
    border: 0.5px solid #166534;
    padding: 3px 11px;
    border-radius: 100px;
    white-space: nowrap;
    margin-top: 2px;
  }

  .cd-location {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    color: #6b7280;
    margin-bottom: 14px;
  }

  .cd-desc {
    font-size: 13px;
    color: #6b7280;
    line-height: 1.65;
    margin: 0;
  }

  /* ── DIVIDER ── */
  .cd-divider {
    height: 0.5px;
    background: rgba(255,255,255,0.06);
    margin: 0 22px;
  }

  /* ── SECTION ── */
  .cd-section { padding: 16px 22px; }

  .cd-section-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: #4b5563;
    margin: 0 0 12px;
  }

  /* contact */
  .cd-contact-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
  }

  .cd-contact-row:last-child { margin-bottom: 0; }

  .cd-icon-box {
    width: 32px;
    height: 32px;
    border-radius: 9px;
    background: #1e1e1e;
    border: 0.5px solid rgba(255,255,255,0.07);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .cd-contact-text {
    font-size: 14px;
    color: #d1d5db;
  }

  /* tax grid */
  .cd-tax-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .cd-tax-cell {
    background: #1a1a1a;
    border: 0.5px solid rgba(255,255,255,0.07);
    border-radius: 11px;
    padding: 13px 15px;
  }

  .cd-tax-label {
    font-size: 11px;
    font-weight: 500;
    color: #4b5563;
    margin: 0 0 5px;
  }

  .cd-tax-value {
    font-size: 15px;
    font-weight: 600;
    color: #e5e7eb;
    margin: 0;
  }

  .cd-qr-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 22px 28px;
  gap: 12px;
}

.cd-qr-box {
  background: #ffffff;
  border-radius: 14px;
  padding: 12px;
  display: inline-flex;
}

.cd-qr-label {
  font-size: 12px;
  color: #4b5563;
  text-align: center;
  margin: 0;
}
`;

const CompanyDetails = () => {
  const canvasRef = useRef(null);
  const { id } = useParams();
  const [company, setCompany] = useState(null);

  useEffect(() => {
    axios
      .get(`${baseURL}/company/get-company-withID/${id}`)
      .then((res) => setCompany(res.data.data));
  }, []);

  useEffect(() => {
    if (company && canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, `${baseURLIO}/company/${id}`, {
        width: 140,
        margin: 2,
        color: {
          dark: "#0a0a0a",
          light: "#ffffff",
        },
      });
    }
  }, [company]);

  if (!company) return <GlobalSpinner />;

  const initials = company.restaurantNam ? company.restaurantName.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase() : "CO";

  const locationParts = [company.restaurantLocation, company.province].filter(Boolean).join(", ");

  return (
    <>
      <style>{styles}</style>
      <div className="cd-page">
        <div className="cd-card">

          {/* Cover */}
          <div className="cd-cover">
            {company.image && (
              <img src={company.image} alt="" aria-hidden="true" />
            )}
            <div className="cd-avatar-wrap">
              <div className="cd-avatar">
                {company.image ? <img src={company.image} alt={company.restaurantName} /> : initials}
                {/* <div className="cd-avatar-tick">
                                    <svg width="9" height="9" viewBox="0 0 12 12" fill="none">
                                        <polyline points="2,6 5,9 10,3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div> */}
              </div>
            </div>
          </div>

          {/* Identity */}
          <div className="cd-body">
            <div className="cd-name-row">
              <div className="cd-name-left">
                <span className="cd-name">{company.restaurantName}</span>
                <VerifiedIcon />
              </div>
              <span className="cd-badge-active">Active</span>
            </div>

            {locationParts && (
              <div className="cd-location">
                <MapPinIcon />
                {locationParts}
              </div>
            )}

            {company.restaurantDesc && (<p className="cd-desc">{company.restaurantDesc}</p>)}
          </div>

          <div className="cd-divider" />

          {/* Contact */}
          <div className="cd-section">
            <p className="cd-section-label">Contact</p>
            {company.phone && (
              <div className="cd-contact-row">
                <div className="cd-icon-box"><PhoneIcon /></div>
                <span className="cd-contact-text">{company.phone}</span>
              </div>
            )}
            {company.email && (
              <div className="cd-contact-row">
                <div className="cd-icon-box"><MailIcon /></div>
                <span className="cd-contact-text">{company.email}</span>
              </div>
            )}
            {/* {company.email && (
                            <div className="cd-contact-row">
                                <div className="cd-icon-box"><LanguageIcon /></div>
                                <span className="cd-contact-text">{company.email}</span>
                            </div>
                        )} */}
          </div>

          <div className="cd-divider" />

          {/* Tax Details */}
          <div className="cd-section" style={{ paddingBottom: 24 }}>
            <p className="cd-section-label">Tax details</p>
            <div className="cd-tax-grid">
              <div className="cd-tax-cell">
                <p className="cd-tax-label">NTN</p>
                <p className="cd-tax-value">{company.ntn || "—"}</p>
              </div>
              <div className="cd-tax-cell">
                <p className="cd-tax-label">STRN</p>
                <p className="cd-tax-value">{company.strn || "—"}</p>
              </div>
            </div>
          </div>

          <div className="cd-divider" />
          {/* QR Code */}
          <div className="cd-qr-section">
            <p className="cd-section-label" style={{ margin: 0 }}>Scan to Visit</p>
            <div className="cd-qr-box">
              <canvas ref={canvasRef} />
            </div>
            <p className="cd-qr-label">{company.restaurantName}</p>
          </div>

        </div>
      </div>
    </>
  );
};

export default CompanyDetails;